/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { AxiosInstance } from 'axios';

import { baseUrl } from './types';

export const sessionsClient = (request: AxiosInstance) => ({
  async admitBrowser(callId: string, sessionId: string): Promise<void> {
    await request.post(`${baseUrl}/sessions/${sessionId}/add-to-call`, { callId });
  },

  async removeBrowser(sessionId: string): Promise<void> {
    await request.delete(`${baseUrl}/sessions/${sessionId}`);
  },
});
